import Resource from './Resource';
class OpportunityAI extends Resource {
	constructor() {
		super('opportunityAI');
	}
}
export default new OpportunityAI();
